export const convertUrlSelectedImage = (src: string, width: number = 960) => {
  return src.replace('.jpg', `_w${width}.jpg`);
};
